export default __webpack_public_path__ + "static/media/mil.8c3dd9e8.png";